<script setup lang="ts">
import type { PropType } from 'vue';

import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt, td, formatUnits } = useTypedI18n();
const { isMonoAsset, isBundleMono } = useSaleType(() => sale.type);

// DATA
const badgeUi = badgeResponsiveSizeUi('md', 'lg');

const firstRegistration = computed(() => (sale.mainAsset.firstRegistration ? Date.parse(sale.mainAsset.firstRegistration) : undefined));
const showKeyAttributes = computed<boolean>(() => isMonoAsset.value || isBundleMono.value);
</script>

<template>
    <div class="flex flex-wrap gap-3">
        <SaleBadges :sale="sale" />

        <div v-if="showKeyAttributes" class="flex gap-3">
            <UBadge v-if="firstRegistration" color="primary-dark" variant="solid" :ui="badgeUi" class="flex gap-x-2" icon="lucide:calendar">
                <span class="hidden md:inline"> {{ tt('asset.firstRegistration') }}: </span>
                {{ td(firstRegistration, 'mmyyyyUTC') }}
            </UBadge>

            <UBadge color="primary-dark" variant="solid" :ui="badgeUi" class="flex gap-x-2" icon="lucide:circle-gauge">
                {{ formatUnits.km(sale.mainAsset.km) }}
            </UBadge>

            <UBadge v-if="sale.mainAsset.euroNorm" color="primary-dark" variant="solid" :ui="badgeUi" class="flex gap-x-2" icon="lucide:bus-front">
                {{ tt(`asset.euroNorm.${sale.mainAsset.euroNorm}`) }}
            </UBadge>
        </div>
    </div>
</template>
